import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { WingViewModelInterface } from "../../view-models/wing/wing-view-model.interface";
import { WingViewComponentInterface } from "../wing-view-component.interface";
import { isConfigurableWingViewModel } from "../../view-models/wing/is-configurable-wing-view-model";
import { WingUiStateChangedEvent } from "../../view-models/wing/wing.types";

@UntilDestroy()
@Component({
  template: '',
  standalone: true,
})
export class BaseWingComponent implements WingViewComponentInterface, OnInit {

  wingViewModel!: WingViewModelInterface;

  constructor(protected readonly cd: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  async initialize(): Promise<void> {
    this.wingViewModel.wingInfoChanged.pipe(untilDestroyed(this)).subscribe((wingInfo) => {
      this.cd.detectChanges();
    });

    if (isConfigurableWingViewModel(this.wingViewModel)) {
      this.wingViewModel.stateChanged$.pipe(untilDestroyed(this)).subscribe(async (event) => {
        if (event.changed.includes('panelState')) {
          await this.onWingCollapsedChanged(event.current.panelState === 'closed');
        }

        await this.onWingUiStateChanged(event);
        this.cd.detectChanges();
      });
      return;
    }

    this.wingViewModel.orchestratorViewModel.eventDispatcher.onWingCollapsed.pipe(untilDestroyed(this)).subscribe((isCollapsed) => {
      this.onWingCollapsedChanged(isCollapsed);
      this.cd.detectChanges();
    });
  }

  async onWingCollapsedChanged(isCollapsed: boolean): Promise<void> {

  }

  async onWingUiStateChanged(event: WingUiStateChangedEvent): Promise<void> {

  }

}
